import { Injectable, ChangeDetectorRef } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { BaseService } from '../../shared/services/base.service';
import { StorageService } from '../../shared/services/storage.service';
import { UtilService } from '../../services/util.service';
import { FieldGroup } from './models/field-group.model';
import { QuestionBase } from './models/question-base.model';
import { TextboxQuestion } from './models/question-textbox.model';
import { CountryMobNoQuestion } from './models/question-countrymobno.model';
import { DropdownQuestion } from './models/question-dropdown.model';
import { RadioQuestion } from './models/question-radiobutton.model';
import { MultiDropdownQuestion } from './models/question-multi-dropdown.model';
import { VideoViewerQuestion } from './models/question-video-viewer.model';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { FileUploaderQuestion } from './models/question-fileuploader.model';
import { SearchAndSelect } from './models/serachselect.model';
import { FormGroup } from '@angular/forms';
import { CheckboxQuestion } from './models/question-checkbox.model';
import { TextareaQuestion } from './models/question-textarea.model';
import { InputSearch } from './models/question-input-search.model';
import { NumberboxQuestion } from './models/question-numberbox.model';
import { PasswordQuestion } from './models/question-password.model';
import { DateRangePickerQuestion } from './models/question-daterangepicker.model';
import { TimePickerQuestion } from './models/question.timepicker.model';
import { HtmlEditorQuestion } from './models/question-html-editor.model'; 
import { HiddenQuestion } from './models/question-hidden.model';
import { CaptchaQuestion } from './models/question-captcha.model';
import { AppService } from '../../shared/services/app.service';
import { FormWithGrid } from './models/FormWithGrid.model';
import { BarcodeQuestion } from './models/question-barcode.model';
import { CompositeArrayQuestion } from './models/question-composite-array.model';
import { InputButtonQuestion } from './models/question-input-button.model';

import { tagInputQuestion } from './models/question-taginput.model';
import { EditGrid } from './models/edit-grid.model';
import { EditableTableQuestion } from './models/question-editable-table.model';
import { LabelQuestion } from './models/question-label.model';
import { ButtonQuestion } from './models/question-button.model';
import { RatingQuestion } from './models/question-rating.model';
import { ScoreQuestion } from './models/question-score.model';
import { PullableQuestion } from './models/question-pullable.model';
import { EditableGrid } from './models/editable-grid.model';
import { Link } from './models/link.model';
import { RangeQuestion } from './models/question-range.model';
import { AlertsService } from '../../services/alerts.service';
import { InclusionExclusion } from './models/question-inclusion-exclusion.model';
import { ActivatedRoute } from '@angular/router';
import { CustomFormQuestion } from './models/question-custom-form.model';
import { monthYearQuestion } from './models/question-monthyear.model';
import { ImageAnnotationQuestion } from './models/question-annotation.model';
import { FlagsQuestion } from './models/question-flags.model';
import { dynamicTableQuestion } from './models/question-dynamic-table.model';
import get from 'lodash-es/get';
import { subHeadingQuestion } from './models/question-subHeading.model';
import { RangeSlider } from './models/question-range-slider.model';
import { PushableQuestion } from './models/question-pushable.model';
import * as CryptoJS from 'crypto-js';
import { of } from 'rxjs';
import { TicketsQuestion } from './models/question-tickets.model';
import moment from 'proxies/dayjs';
import { SignatureQuestion } from './models/question-signature.model';
import { TextEntryQuestion } from '../assessment-form/models/question-textentry.model';
import { SingleChoiceQuestion } from '../assessment-form/models/question-single-choice.model';
import { FingerprintQuestion } from './models/question-fingerprint.model';
import { ImageEditorQuestion } from './models/question-image-editor.model';

@Injectable()
export class FormService {

  public optionChanged = new BehaviorSubject<any>(null); //to emit that options are set for dropdown

  fieldGroup: any = [];
  activeKey: any;
  group_type: any = '';
  refresh: Observable<any>;
  private questionsSub = {};
  questionMapping: any = {};
  compositeQuestionMapping: any = {};
  compositeFormMapping: any = {};
  cardData: any;
  form: FormGroup;
  action: any;
  labelCol: any;
  popupForm: FormGroup;
  data: any;
  auto_fill_banner: boolean = true;
  showAddData: boolean = false;
  selected: any;
  editableGrid: boolean = false;
  blockMapping: FieldGroup[];
  blocksChange: Array<any> = [];
  config: any;
  keyValue: any;
  formatValue: any;
  fromRuntime: any=false;
  
  // InitialVal: any = {};
  constructor(
    public baseService: BaseService,
    public alerts: AlertsService, // for decorator use
    public authenticationService: AuthenticationService,
    public storageService: StorageService,
    public utilService: UtilService,
    public appService: AppService,
    public route: ActivatedRoute,
  ) {

  }
  setBlockMapping(blockMapping) {
    this.blockMapping = blockMapping;
  };
  setForm(val) {
    this.form = val;
  }
  setArrayForm(val) {
    this.popupForm = val;
  }
  setAutoFillFromNanner(val) {
    this.auto_fill_banner = val;
  }
  setAddData(val) {
    this.showAddData = val;
  }
  setEditableGrid(val) {
    this.editableGrid = val;
  }
  setInputValue(fieldGroup, action, field, question, self, fillData?) {
    var application = this.appService.getApplication();
    this.action = action;
    var val: any = 0
    if ((action == 'ADD' || (action == 'SEARCH' && fieldGroup.filterDataFill)) && this.auto_fill_banner) {
      if (field['condition'] && field['condition'] != undefined) {
        var found = field['condition'].find(function (element) {
          return element.application == application
        });
        // console.log("Found is ",found);
        if (found != undefined) {
          val = this.setDataInForm(fieldGroup, field, self, fillData, found.getterKey);
        } else {
          val = this.setDataInForm(fieldGroup, field, self, fillData, field['name']);
        }
      }
      // else if(question.value != undefined){
      //   val = question['value'];
      // }
      else {
        if (this.showAddData && !this.fromRuntime && field.set_banner_data == undefined)
          val = this.setDataInForm(fieldGroup, field, self, undefined, field['name']);
        else
          val = this.setDataInForm(fieldGroup, field, self, fillData, field['name']);
      }
    } else {
      if (question.controlType == "daterangepicker" && question.singleDatePicker == false) // Reverify for composite object date
      {
        if (self.data) {
          if (field['startKey'] != undefined && field['endKey'] != undefined && (self.data)[field['startKey']] != undefined && (self.data)[field['endKey']] != undefined) {
            val = {};
            val[field.startKey] = (self.data)[field['startKey']];
            val[field.endKey] = (self.data)[field['endKey']]
          } else if (this.utilService.flatten(self.data)[field.name + "." + field['startKey']] && this.utilService.flatten(self.data)[field.name + "." + field['endKey']]) {
            val = {};
            val[field.startKey] = this.utilService.flatten(self.data)[field.name + "." + field['startKey']]
            val[field.endKey] = this.utilService.flatten(self.data)[field.name + "." + field['endKey']]
          } else
            val = (self.data)[field['name']];
        }
      }
      else {
        if (field['proxy_name'] != undefined) {
          val = (self.data && this.utilService.flatten(self.data)[field['proxy_name']]);
        } else if (field.component == 'textbox-button') { // getting value at time of update
          if (self.data) {
            val = (self.data)[field['name']];
          }
        }
        else { // for multiple form
          if (field['editableGridAutofill'] != undefined && !field['editableGridAutofill'] && self.data && self.data['set_data'] == undefined) {
          } else
            val = (self.data && this.utilService.flatten(self.data)[field['name']]);
        }
      }

    }
    if (val || val === 0 || (question.controlType == "checkbox")) {
      if (question.value == '' || question.value == undefined || ((question.value == "0" || question.value == "0.00") && question.controlType == "numberbox")) {
        question.value = val;
      }
      else if ((this.action == 'MODIFY' || this.action == 'VIEW') || question.value == '' || question.value == undefined || (question.value == "0" && question.controlType == "numberbox") || (val != undefined && val)) {
        question.value = val;
      }
      // else if (question.controlType == "timepicker") {
      //   question.value = val;
      // }
      // else if(question.controlType == "hidden"){ // Sanjay : Please check with me for this condition, I hope it should work in every condition
      //   question.value = val; 
      // }
      else if (question.controlType == "edit_grid") { // Sanjay : Please check with me for this condition, I hope it should work in every condition
        question.value = val;
      }
    }
  }
  setDataInForm(fieldGroup, field, self, fillData?, key?) {
    if (key == undefined) {
      key = field['name'];
    }
    var val = field.hasOwnProperty('setDefault') && field.setDefault == false ? '' : 0;
    var formFill = field['formAutofill'];// For not showing fields autofilled
    if (field['formAutofill'] == undefined || field['formAutofill']) {
      formFill = true;
    }
    if (fillData != undefined) {
      let keyData = get(fillData, key);
      if (keyData != undefined || fillData.hasOwnProperty(key) || fillData.hasOwnProperty(field['name'])) {
        if (formFill) {
          val = (fillData && this.utilService.flatten(fillData)[key]);
          if (val == undefined && key != field['name']) {
            val = (fillData && this.utilService.flatten(fillData)[field['name']]);
          }
        }
      } else {
        this.storageService.getAutofillData(fieldGroup.id, (localData) => {
          if (localData && localData.formAutofill && fieldGroup.id == localData.formId) {
            if (formFill)
              val = (localData[localData.formId][0] && this.utilService.flatten(localData.data)[key]);
          }
        });
      }
    } else {
      if (formFill) {
        val = (self.data && this.utilService.flatten(self.data)[field['name']]);
        if (val == undefined && key != field['name']) {
          val = (self.data && this.utilService.flatten(self.data)[key]);
        }
      }
    }
    return val;
  }

  getDictionary(url: string, queryId: any = false, application?: any, args?: any, filter?: any, field?: any, read_scope?: any): Observable<any> {
    var queryId = (queryId) ? queryId : 'GET_ALL';
    var application = (application) ? application : '';
    var projectionKeys: any = "";

    if (field != undefined && field['req_keys'] && field['req_keys'] != 'all') {
      projectionKeys = this.baseService.getProjectionKeys([field['getterKey'], field['getterValue']], field['req_keys'], 'dropdown');
    } else if (field != undefined && (field['req_keys'] == undefined || !field['req_keys'])) {
      projectionKeys = this.baseService.getProjectionKeys([field['getterKey'], field['getterValue']], field['req_keys'], 'dropdown');
    }

    if (args == null) {
      args = '';
    }
    let obj = { args: args, filter: filter != undefined && filter ? filter : '', projectionKeys: projectionKeys };

    if(field!=undefined && field.datasource!=undefined && field.datasource.page_size!=undefined && field.datasource.page_size){
      obj['page_size'] = field.datasource.page_size;
    }
    if (field != undefined && field['datasource'] && !field.datasource.readPreference) {
      obj['readPreference'] = 'secondaryPreferred';
    }
    if (read_scope != undefined)
      obj['read_scope_level'] = 'account';

    //-----------------------implementing no count by default for alll--------------------------------//
    if (obj.args != undefined && obj.args.includes("noCount")) {
      //do nothing
    }
    else if (obj.args != undefined && obj.args) {
      obj.args = obj.args + ",noCount:1"
    }
    else {
      obj.args = "noCount:1"
    }
    //-----------------------implementing no count by default for alll ends--------------------------------//

    //-------------valueset cacheing mechanism start--------------------------//  
    if (field != undefined && field['datasource'] != undefined && field['datasource'].query_id && field['datasource'].query_id == 'get_valueset_by_id_flat') {
      field['datasource'].cachable = true;  // set cachable true always for valueset query
    }
    //-------------valueset cacheing mechanism end--------------------------//  

    //-------------dropdown cacheing mechanism start--------------------------//  
    if (field != undefined && field['datasource'] != undefined && field['datasource'].cachable) {
      try {
        let cacheObj = obj.args + obj.filter + obj.projectionKeys + url + application + queryId;
        let key = CryptoJS.MD5(cacheObj).toString();
        if (this.baseService.getCachedData(key)) {
          return of(this.baseService.getCachedData(key)).pipe(delay(0));
        }
        else {
          return this.baseService.getData(obj, '', url, application, queryId)
            .pipe(map(res => this.extractData(res.resource, cacheObj)));
        }
      } catch (error) {
        console.error(error);
      }
    }
    //-------------dropdown cacheing mechanism end--------------------------//

    else {
      return this.baseService.getData(obj, '', url, application, queryId)
        .pipe(map(res => this.extractData(res.resource)));
    }

  }

  getDictionaryCombobox(url: string, filter: string): Observable<any> {
    return
  }
  /**
   * for buiding Formgroup
   */
  setCardData(cardData, config) {
    this.cardData = cardData;
    this.config = config;
  }

  addDynamicValidation(field) {
    //check if dynamic validations is set from currentsession of app service ( we could extend it further)
    if (field['validations'] != undefined && field['validations']["dynamic"] != undefined && this.appService._currentSessionData[field['validations']["dynamic"]] != undefined && this.appService._currentSessionData[field['validations']["dynamic"]]) {
      //override the pattern, remove min and max length (in case of dynamice validation we expect pattern all the validation in itself)
      field['pattern'] = this.appService._currentSessionData[field['validations']["dynamic"]];
      delete field['maxlength'];
      delete field['minlength'];
    }
  }
  buildFormGroup(self?, fieldGroupObj: any = false, key?): FieldGroup[] {
    this.data = self.data;
    this.fromRuntime = self.fromRuntime!=undefined?self.fromRuntime:false;
    // this.cardData = cardData;
    let fieldGroup: any = [];
    let blockObj = {};
    console.log("FieldGroup ", this.fieldGroup);
    this.fieldGroup = (fieldGroupObj) ? fieldGroupObj : this.fieldGroup;
    if (this.fieldGroup.blocks && this.fieldGroup.blocks.length) {
      this.activeKey = this.fieldGroup.blocks[0].name;
      if (this.fieldGroup.blocks[0].group_type || this.fieldGroup.blocks[0].group_type != undefined) {
        this.group_type = this.fieldGroup.blocks[0].group_type;
        console.log("Group type ", this.group_type);
      }
    }
    let f = this.fieldGroup.blocks.sort((a, b) => { return a.order - b.order });
    fieldGroup = f.map((fGroup) => {
      let field: any = {};
      field.title = fGroup.title || '';
      field.className = (fGroup.class != undefined || fGroup.class_name != undefined) ? (fGroup.class || fGroup.class_name) : null;
      field.group_type = (this.action == "VIEW") ? "" : fGroup.group_type || '';
      field.name = fGroup.name;
      field.block_id = (fGroup.block_id) || fGroup.name;
      if (fGroup.group_type == 'accordian') {
        field.default_open = (fGroup.group_type && fGroup.default_open != undefined && fGroup.default_open === true) ? fGroup.default_open : "";
      } else if (fGroup.group_type == 'scroll-tab') {
        field.default_open = (fGroup.group_type && fGroup.default_open != undefined && fGroup.default_open === true) ? fGroup.default_open : true;
      } else {
        field.default_open = true;
      }
      console.log("default open is as follows at form::", field.default_open);
      field.visible = (fGroup.visible == undefined && key == undefined) ? true : fGroup.visible || key || false;
      field.disabled = (fGroup.disabled == undefined && key == undefined) ? false : fGroup.disabled || key || true;
      field.required = (fGroup.required != undefined) ? fGroup.required : false;

      //this will help in sending invisible keys
      field['sendInvisible'] = (fGroup.sendInvisible != undefined && fGroup.sendInvisible) ? fGroup.sendInvisible : false;


      if (this.config && !this.config.isTemplate) {
        field['layout_type'] = fGroup.layout_type ? fGroup.layout_type : 'three-column';
      }
      field['template'] = (fGroup.template != undefined && fGroup.template) ? fGroup.template : false;//for check template block
      if (fGroup.pullable_id != undefined) {
        field['pullable_id'] = fGroup.pullable_id ? fGroup.pullable_id : '';
        field['pullableData'] = (fGroup.pullableData != undefined && fGroup.pullableData) ? fGroup.pullableData : undefined;
        if (fGroup.pullable_key_mapping != undefined && fGroup.pullable_key_mapping.length > 0)
          field['pullable_key_mapping'] = fGroup.pullable_key_mapping ? fGroup.pullable_key_mapping : undefined;
      }
      blockObj = {};
      blockObj['block_id'] = field.block_id ? field.block_id : '';
      blockObj['visible'] = field.visible.hasOwnProperty('visible') ? field.visible.visible : field.visible;
      blockObj['disabled'] = field.disabled.hasOwnProperty('disabled') ? field.disabled.disabled : field.disabled;
      //console.log(field, fGroup, blockObj);
      // if (fGroup.scoreType != undefined && fGroup.scoreType == 'score') { // This condition only score type of block
      //   field.fields = fGroup['fields'];
      //   field.questions = [];
      //   field.scoreData = fGroup['scoreData'];
      // } else {
      if (this.config && !this.config.isTemplate && fGroup != undefined && fGroup['fields'] != undefined && fGroup['fields'].length != undefined && fGroup['fields'].length) {
        let composite_Array = fGroup['fields'].find(x => x.type != undefined && x.type === "COMPOSITE-ARRAY");
        if (composite_Array) {
          field['layout_type'] = "one-column";
        }
      }
      field.questions = this.buildQuestions(fGroup['fields'], blockObj, self);
      field.questions.sort((a, b) => { return a.order - b.order });
      // }
      return field;
    });
    if (fieldGroupObj.label != undefined) {
      fieldGroup.label = fieldGroupObj.label;
    }
    if (fieldGroupObj.name != undefined) {
      fieldGroup.name = fieldGroupObj.name;
    }
    if (fieldGroupObj.resource != undefined) {
      fieldGroup.resource = fieldGroupObj.resource;
    }
    if (fieldGroupObj.array_type != undefined) {
      fieldGroup.array_type = fieldGroupObj.array_type;
    }
    if (fieldGroupObj.hide_array_button != undefined) {
      fieldGroup.hide_array_button = fieldGroupObj.hide_array_button;
    }
    return fieldGroup;
  }
  /**
   * For question building that is for mapping model
   */
  buildQuestions(fields?: any, key?: any, InitialVal?): QuestionBase<any>[] {
    let questions = [];
    let self = InitialVal;
    return questions = fields.map((field) => {
      let question: any = {};
      if (field.type == 'COMPOSITE-ARRAY') {
        if (field.component == 'composite-array') { } else {
          field.resource = field.component;
          field.component = 'composite-array';
        }
      }

      if (field.type == 'EDITABLE-TABLE') {
        if (field.component == 'editable-table') { } else {
          field.resource = field.component;
          field.component = 'editable-table';
        }
      }

      if (field.blocks == undefined) {
        var componentFound = false;
        switch (field['component'] || field['controlType']) {
          case 'label':
            question = new LabelQuestion({
              key: field['name'],
              label: field['label'],
              popover: field['popover'],
              type: field['type'],
              format: field['format'],
              visible: field['visible'] != undefined ? field['visible'] : true,
              order: field['order'],
              view_required: field['view_required'] != undefined ? field['view_required'] : false,
              class_conditions: field['class_conditions'],
              grid_color_text: field['grid_color_text'],
              conditions: field['conditions'],
              flag: field['flag'],
              sortable: field['sortable'],
              conversion: field['conversion'],
              required: field['required'],
              currentStage: field['currentStage'],
              image_conditions: field['image_conditions'],
              show_popover: field['show_popover'],
            });
            break;
          case 'flags':
            question = new FlagsQuestion({
              key: field['name'],
              type: field['type'],
              label: field['label'],
              format: field['format'],
              visible: field['visible'] != undefined ? field['visible'] : true,
              order: field['order'],
              view_required: field['view_required'] != undefined ? field['view_required'] : false,
              flag_condition: field['flag_condition'],
            });
            break;
          case 'link':
            question = new Link({
              key: field['name'],
              label: field['label'] ? field['label'] : '',
              action_name: field['action_name'],
              aciton_type: field['aciton_type'],
              action_config: field['action_config'],
              changeable:field['changeable']
            });
            break;
          case 'subHeading':
            question = new subHeadingQuestion({
              show_label: false,
              key: field['name'],
              value: field['title'],
              order: field['order']
            });
            break;
          case 'button':
            question = new ButtonQuestion({
              key: field['name'] || field['key'],
              label: field['label'],
              type: field['type'],
              name: field['buttonName'],
              required: field['required'],              
              class: field['buttonClass'],
              buttonIcon: field['buttonIcon'],
              order: field['order'],
              disabled: field['disabled'],
              visible: field['visible'],
              show_label: field['show_label'],
              id: field['id'],
              permission_check: field['permission_check'],
              emitOnSave: field['emitOnSave'] != undefined ? field['emitOnSave'] : true
            });
            break;
          case 'textbox':
            this.addDynamicValidation(field);
            question = new TextboxQuestion({
              key: field['name'],
              label: field['label'],
              type: field['type'],
              required: field['required'],
              placeholder: field['hint'],
              maxlength: field['maxlength'],
              minlength: field['minlength'],
              order: field['order'],
              pattern: field['pattern'],
              trim: field['trim'], // Not in use
              disabled: field['disabled'],
              value: field['default'] || field['default_val'] || '', // need to check for default_val
              visible: field['visible'],
              asyncValidation: field['asyncValidation'], // need to check 
              searchable: field['searchable'], // need to check 
              formAutofill: field['formAutofill'],
              conditions: field['conditions'],
              macro_support: field['macro_support'] || false,
              macro_datasource: field['macro_datasource'],
              cstm_error_msg: field['cstm_error_msg'],
              textCapitalize: field['textCapitalize'],
              asideButton: field['asideButton'],
              text_buttonIcon: field['text_buttonIcon'],
              additional_space: field['additional_space']
            });
            if (field.macro_support) {
              if (question.macro_datasource == undefined || !question.macro_datasource || (typeof (question.macro_datasource) == 'object' && Object.keys(question.macro_datasource).length === 0)) {
                question.macro_datasource = {
                  "application": "form-template-engine",
                  "resource": "macros",
                  "query_id": "GET_MACROS",
                }
              }
            }
            if (question.pattern == 'email') {
              question.pattern = '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$'
            }
            else if (question.pattern == 'url') {
              question.pattern = "^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$"
            } else if (question.pattern == 'phone') {
              question.pattern = '[0-9]*'
              question.minlength = 8,
                question.maxlength = 12
            } else if (question.pattern == 'pincode') {
              question.pattern = '[0-9]*',
                question.minlength = 6,
                question.maxlength = 6
            } else if (question.pattern == '#No') {
              question.pattern = '^[0-9+]*$'
            }
            componentFound = true;
            // console.log("Question is ", question);
            break;
          case 'countrymobno':
            question = new CountryMobNoQuestion({
               key: field['name'],
               label: field['label'],
               type: field['type'],
               required: field['required'],
               maxlength: field['maxlength'],
               class_name: field['class_name'],
               order: field['order'],
               parameter:field['parameter'],
               separateDialCode:field['separateDialCode'],
               numberFormate:field['numberFormate'],
               preferredCountries:field['preferredCountries'],
               selectedCountryISO:field['selectedCountryISO'],
               enablePlaceholder: field['enablePlaceholder'],
               phoneValidation: field['phoneValidation'],
               searchCountryFlag: field['searchCountryFlag']
             });
             componentFound = true;
             break;
          case 'dropdown':
            question = new DropdownQuestion({
              key: field['name'],
              label: field['label'],
              required: field['required'],
              id: field['id'],
              getterKey: field['getterKey'] || 'id',
              getterValue: field['getterValue'] || 'value',
              param: field['param'],
              disabled: field['disabled'],
              config: field['config'],
              order: field['order'],
              flag: field['flag'],
              conditions: field['conditions'],
              datasource: field['datasource'],
              visible: field['visible'],
              populate_field: field['populate_field'],
              req_keys: field['req_keys'],
              resource_add: field['resource_add'],
              defaultValue: field['defaultValue'],
              formAutofill: field['formAutofill'],
              format: field['format'],
              default: field['default'] || field['default_val'] || '',
              view_key: field['view_key'],
              index: field['index'],
              class_conditions: field['class_conditions'],
              stopSorting: field['stopSorting'],
              sortType: field['sort_type'],
              removeSelect: field['removeSelect'],
              sortBy: field['sortBy'],
              showMore:field['showMore'],
              getAssignedFacilityList: field['getAssignedFacilityList']
            });
            if(question.getAssignedFacilityList && this.appService.getOrgList().length > 0){
              // question.datasource = {possible_value: this.appService.getOrgList()}
              field.datasource = {possible_value: this.appService.getOrgList()}
              // question.value = this.appService.getOrganizationList().length > 0 ? this.appService.getOrganizationList()[0][question.getterKey] : '';
            }
            if (question.default != null && (this.action == 'ADD' || this.action == 'SEARCH')) {
              question.value = question.default.trim != undefined ? question.default.trim() : question.default;
            }

            if (this.questionsSub[question.key]) {
              this.questionsSub[question.key].unsubscribe();
            }
           if (field.datasource != undefined) {
              field.datasource.application = field.datasource.application || '';
            }
            else {
              field['datasource'] = {};
              field['datasource']['application'] = '';
            }

            if (this.refresh) {
              this.questionsSub[question.key] = this.refresh.subscribe(_ => this.getDictionary(field.datasource.resource, field.datasource.query_id, field.datasource.application, '', '', field, field.datasource.read_scope_level)
                .subscribe(
                  (data) => {
                    question.options = data;
                  }));
            }
            if (!(question.view_key && this.action == 'VIEW' && this.form != undefined && this.form[question.view_key] != undefined)) {
              this.setdropdownOptions(field, question, self);
            }

            componentFound = true;
            break;

          case 'pullable':
            question = new PullableQuestion({
              key: field['name'],
              label: field['label'],
              required: field['required'],
              id: field['id'],
              getterKey: field['getterKey'] || 'id',
              getterValue: field['getterValue'] || 'value',
              param: field['param'],
              disabled: field['disabled'],
              config: field['config'],
              order: field['order'],
              flag: field['flag'],
              conditions: field['conditions'],
              pullableData: field['pullableData'] || {},
              pullable_response_array: field['pullable_response_array'] || [],
              complex_search: field['complex_search'] || [],
              filter: field['filter'],
              bannerJson: this.fieldGroup['bannerJson'],
              visible: field['visible'],
              populate_field: field['populate_field'],
              req_keys: field['req_keys'],
              resource_add: field['resource_add'],
              defaultValue: field['defaultValue'],
              formAutofill: field['formAutofill'],
              format: field['format'],
              default: field['default'],
              view_key: field['view_key'],
              auto_pullable: field['auto_pullable'],
              fields: field['fields'] || [],//data grid fields for view form
            });

            if (question.value == undefined || question.value == null || question.value == '') {
              question.value = [];
            } else if (question.default != null && this.action == 'ADD') {
              question.value = question.default;
            }
            componentFound = true;
            break;
          case 'pushable':
            question = new PushableQuestion({
              key: field['name'],
              label: field['label'],
              required: field['required'],
              id: field['id'],
              disabled: field['disabled'],
              order: field['order'],
              conditions: field['conditions'],
              bannerJson: this.fieldGroup['bannerJson'],
              visible: field['visible'],
              frontend_resource: field['frontend_resource'],
              default: field['default'],
              view_key: field['view_key'],
              pushable_master: field['pushable_master']
            });
            if (this.config && this.config.isTemplate && this.data && this.data._type == 'copy') {
              question['isCopyTemplate'] = true;//185806 add flag in case copy template
            }
            break;
          case 'radio':
            question = new RadioQuestion({
              key: field['name'],
              label: field['label'],
              required: field['required'],
              getterKey: field['getterKey'] || 'id',
              getterValue: field['getterValue'] || 'value',
              //options: field.datasource.possible_value,
              //options: field['options'],
              order: field['order'],
              default: field['default'] || field['default_val'] || '',
              disabled: field['disabled'],
              visible: field['visible'],
              view_label: field['view_label'],
              conditions: field['conditions']
            });
            if (question.value == undefined) {
              question.value = question['default'];
            }
            if (field.datasource != undefined) {

              field.datasource.application = field.datasource.application || '';
              if (!field.datasource.possible_value) {

                this.getDictionary(field.datasource.resource, field.datasource.query_id, field.datasource.application, field?.datasource?.args, field?.datasource?.filter)
                  .subscribe(
                    (data) => {

                      question.options = this.mapDictToArray(data, field);
                    }
                  );
              }
              else {
                question.options = field.datasource.possible_value;
              }
            }
            componentFound = true;
            break;
          case 'multi-dropdown':
            question = new MultiDropdownQuestion({
              key: field['name'],
              label: field['label'],
              id: field['id'],
              getterKey: field['getterKey'] || 'id',
              getterValue: field['getterValue'] || 'value',
              param: field['param'],
              order: field['order'],
              required: field['required'],
              config: field['config'],
              disabled: field['disabled'],
              visible: field['visible'],
            });
            if (this.questionsSub[question.key]) {
              this.questionsSub[question.key].unsubscribe();
            }
            if (this.refresh) {
              this.questionsSub[question.key] = this.refresh.subscribe(_ => this.getDictionary(field['dictionaryUrl'])
                .subscribe(
                  (data) => {
                    question.options = data;
                  }));
            }
            this.setdropdownOptions(field, question, self);
            if (question.value == null)
              question.value = [];
            componentFound = true;
            break;
          case 'checkbox':
            question = new CheckboxQuestion({
              key: field['name'],
              label: field['label'],
              required: field['required'],
              order: field['order'],
              htmlText: field['htmlText'],
              text: field['label'],
              disabled: field['disabled'],
              visible: field['visible'],
              value: field['default'] || field['default_val'] || '',
              type: field['type'],
              is_rich_text: field['is_rich_text'],
              is_label_required: field['is_label_required'],
              conditions: field['conditions'],
              view_key: field['view_key'],
              format: field['format'],
              getterKey: field['getterKey'] || 'id',
              getterValue: field['getterValue'] || 'value',
              calculated_field_type: field['calculated_field_type'],
              calculation_formula: field['calculation_formula'],
              select_defination: field['select_defination'],
              MultiCkbLayout: field['MultiCkbLayout']
            });
            if (this.questionsSub[question.key]) {
              this.questionsSub[question.key].unsubscribe();
            }
            if (this.refresh) {
              this.questionsSub[question.key] = this.refresh.subscribe(_ => this.getDictionary(field['dictionaryUrl'])
                .subscribe(
                  (data) => {
                    question.options = data;
                  }));
            }
            if (field['datasource'] && field['datasource'] != undefined)
              this.setdropdownOptions(field, question, self);
            if (question.value == null)
              question.value = [];
            componentFound = true;
            break;
          case 'textarea':
            question = new TextareaQuestion({
              key: field['name'],
              label: field['label'],
              order: field['order'],
              required: field['required'],
              pattern: field['pattern'],
              placeholder: field['hint'],
              disabled: field['disabled'],
              visible: field['visible'],
              minlength: field['minlength'],
              formAutofill: field['formAutofill'],
              maxlength: field['maxlength'],
              macro_support: field['macro_support'] || false,
              macro_datasource: field['macro_datasource'],
              value: field['default'] || field['default_val'] || '',
              rows: field['rows'],
              conditions: field['conditions'],
              additional_space: field['additional_space']
            });
            if (field.macro_support) {
              if (question.macro_datasource == undefined || !question.macro_datasource || (typeof (question.macro_datasource) == 'object' && Object.keys(question.macro_datasource).length === 0)) {
                question.macro_datasource = {
                  "application": "form-template-engine",
                  "resource": "macros",
                  "query_id": "GET_MACROS",
                }
              }
            }
            componentFound = true;
            break;
          case 'inputSearch':
            question = new InputSearch({
              key: field['name'],
              label: field['label'],
              order: field['order'],
              required: field['required'],
              pattern: field['pattern'],
              disabled: field['disabled'],
              showAdvSearch: field['showAdvSearch'],
              clearSearch: field['clearSearch'],
              visible: field['visible'],
              datasource: field['data'],
              hint: field['hint'],
              conditions: field['conditions'],
            });
            // if (question.value == null)
            //   question.value = {};
            componentFound = true;
            break;
          case 'taginput':
            question = new tagInputQuestion({
              key: field['name'],
              label: field['label'],
              order: field['order'],
              required: field['required'],
              disabled: field['disabled'],
              visible: field['visible'],
            });
            if (question.value == null)
              question.value = [];
            componentFound = true;
            break;
            case 'kx-video':
            question = new VideoViewerQuestion({
              key: field['name'],
              label: field['label'],
              order: field['order'],
              required: field['required'],
              video_path: field['video_path'],
              video_type: field['video_type'],
              visible: field['visible'],
            });
            if (question.value == null){
              question.value = field['video_path'];
            }
            componentFound = true;
            break;
          case 'annotation':
            question = new ImageAnnotationQuestion({
              key: field['name'],
              label: field['label'],
              order: field['order'],
              visible: field['visible'],
              type: field['type'],
              datasource: field['datasource']
            });
            if (question.value == null)
              question.value = "";
            componentFound = true;
            break;
          case 'numberbox':
            question = new NumberboxQuestion({
              key: field['name'],
              label: field['label'],
              order: field['order'],
              required: field['required'],
              type: field['type'],
              placeholder: field['hint'],
              fieldType: field['type'],
              pattern: field['pattern'],
              disabled: field['disabled'],
              visible: field['visible'],
              formAutofill: field['formAutofill'],
              min: field['min'],
              max: field['max'],
              step: field['step'] || 0,
              validations: field['validations'],
              setDefault: field['setDefault'] == undefined || field['setDefault'] ? true : field['setDefault'],
              conditions: field['conditions'],
              cstm_error_msg: field['cstm_error_msg'],
              tooltip_key: field['tooltip_key']
            });
            if (field['setDefault'] == undefined || field['setDefault']) {
              question['value'] = field['default'] || 0;
            } else {
              question['value'] = field['default'] || field['default_val'] || '';
            }
            componentFound = true;
            break;
          case 'password':
            question = new PasswordQuestion({
              key: field['name'],
              label: field['label'],
              required: field['required'],
              order: field['order'],
              controlToValidate: field['controlToValidate'],
              maxlength: field['maxlength'],
              minlength: field['minlength'],
              placeholder: field['hint'],
              visible: field['visible'],
              disabled: field['disabled'],
              conditions: field['conditions'],
              pattern:field['pattern'],
              password_hint: field['password_hint'],
              // pattern : "(?=^.{8,16}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$",
              changeEvent: true //field['changeEvent']
            });
            componentFound = true;
            break;
          case 'daterangepicker':
            question = new DateRangePickerQuestion({
              key: field['name'],
              label: field['label'],
              order: field['order'],
              required: field['required'],
              disabled: field['disabled'],
              visible: field['visible'],
              conditions: field['conditions'],
              singleDatePicker: field['singleDatePicker'],
              locale: field['locale'],
              autoApply: field['autoApply'],
              showClearButton: field['showClearButton'],
              timePicker: field['timePicker'],
              timePickerSeconds: field['timePickerSeconds'],
              timePickerIncrement: field['timePickerIncrement'],
              timePicker24Hour: field['timePicker24Hour'],
              minDateNumber: field['minDateNumber'],
              minDateUnit: field['minDateUnit'],
              maxDateNumber: field['maxDateNumber'],
              maxDateUnit: field['maxDateUnit'],
              outPutFormat: field['outPutFormat'],
              showDropdowns: field['showDropdowns'],
              selected: field['selected'],
              showCustomRangeLabel: field['showCustomRangeLabel'],
              startKey: field['startKey'],
              endKey: field['endKey'],
              validations: field['validations'],
              enableInput: field['enableInput'],
              minDate: field['minDate'],
              value: field['default'] || field['default_val'] || '',
              maxDate: field['maxDate'],
              type: field['type'],
              maxSpan: field['maxSpan'],
              forceEndOfDay: field['forceEndOfDay'],
              startOfDay: field['startOfDay'],
              randomSelection: field['randomSelection'],
              defaultDaysAfter: field['defaultDaysAfter'],
              priorDate : field['priorDate'],
              subsequentDate :field['subsequentDate'],
              calculated_field_type: field['calculated_field_type'],
              calculation_formula: field['calculation_formula'],
              select_defination: field['select_defination'],
              endOfDayTime: field['endOfDayTime']
            });
            if (question.hasOwnProperty('selected') && question.selected) {
              if (question.singleDatePicker != undefined && question.singleDatePicker == false) {
                if (question.value == null || question.value == '' || question.value == undefined) {
                  if (question.startKey && question.endKey) {
                    question.value = {}
                    question.value[question.startKey] = this.baseService.getTodayMillis();
                    question.value[question.endKey] = field['endOfDay'] ? this.baseService.getTodayEndMillis() : this.baseService.getCurrentDate()
                  } else {
                    question.value = {
                      "FROM": this.baseService.getTodayMillis(),
                      "TO": field['endOfDay'] ? this.baseService.getTodayEndMillis() : this.baseService.getCurrentDate(),
                    }
                  }
                }
              }
              else if ((question.value == null || question.value == '' || question.value == undefined) && field.incrementNo != undefined) {
                var d = new Date();
                d.setHours(0, 0, 0, 0);
                question.value = d.getTime() + (field.incrementNo * (86400 * 1000));
              }
              else if (question.value == null || question.value == '' || question.value == undefined) {
                question.value = new Date().getTime()
              }
            }
            else if (question.randomSelection != undefined && question.randomSelection) {
              question.value = this.getDateRangeFromString(question.randomSelection,field)
            }
            else if (question.defaultDaysAfter != undefined && question.defaultDaysAfter) {
              question.value = this.getAfterRangeFromString(question.defaultDaysAfter)
            }
            else if (question.priorDate != undefined && question.priorDate && question.subsequentDate != undefined && question.subsequentDate) {
              question.value = {
                "TO": moment().add(question.priorDate, 'days').startOf('day').valueOf(),
                "FROM": moment().subtract(question.subsequentDate, 'days').startOf('day').valueOf(),
              }
            }
            else if (question.priorDate != undefined && question.priorDate) {
              question.value = {
                "TO": moment().add(question.priorDate, 'days').startOf('day').valueOf(),
                "FROM": this.baseService.getTodayMillis(),
              }
            }
            else if (question.subsequentDate != undefined && question.subsequentDate) {
              question.value = {
                "TO": this.baseService.getTodayMillis(),
                "FROM": moment().subtract(question.subsequentDate, 'days').startOf('day').valueOf()
              }
            }
           
            
            if (question.value == null) {
              question.value = '';
            }
            componentFound = true;
            break;
          case 'timepicker':
            question = new TimePickerQuestion({
              key: field['name'],
              label: field['label'],
              order: field['order'],
              required: field['required'],
              disabled: field['disabled'],
              visible: field['visible'],
              locale: field['locale'],
              timePickerSeconds: field['timePickerSeconds'],
              timePickerIncrement: field['timePickerIncrement'],
              timePicker24Hour: field['timePicker24Hour'],
              selected: field['selected'],
              startOfDay: field['startOfDay'],
              minDateNumber: field['minDateNumber'],
              minDateUnit: field['minDateUnit'],
              maxDateNumber: field['maxDateNumber'],
              maxDateUnit: field['maxDateUnit'],
              validations: field['validations'],
              value: field['default'] || field['default_val'] || '',
            });
            if (question.hasOwnProperty('selected') && question.selected) {
              if (question.value == null || question.value == '' || question.value == undefined) {
                let startofDay;
                if (question.startOfDay)
                  startofDay = new Date().setHours(0, 0, 0, 0)
                else
                  startofDay = new Date().getTime()
                question.value = startofDay
              }
            }
            if (question.value == null)
              question.value = '';
            componentFound = true;
            break;
          case 'html-editor':
            question = new HtmlEditorQuestion({
              key: field['name'],
              label: field['label'],
              required: field['required'],
              format: field['format'],
              modules: field['modules'],
              order: field['order'],
              placeholder: field['hint'],
              style: field['style'],
              disabled: field['disabled'],
              visible: field['visible'],
              maxlength: field['maxlength'],
              value: field['default'] || field['default_val'] || '',
              customConfig: field['customConfig'],
              macro_support: field['macro_support'] || false,
              macro_datasource: field['macro_datasource']
            });
            if (field.macro_support) {
              if (question.macro_datasource == undefined || !question.macro_datasource || (typeof (question.macro_datasource) == 'object' && Object.keys(question.macro_datasource).length === 0)) {
                question.macro_datasource = {
                  "application": "form-template-engine",
                  "resource": "macros",
                  "query_id": "GET_MACROS",
                }
              }
            }
            componentFound = true;
            break;
          case 'dynamic-table':
            question = new dynamicTableQuestion({
              order: field['order'],
              label: field['label'],
              key: field['name'],
              value: field['default'] || null,
              tabular_list: field['tabular_list']
            });
            componentFound = true;
            break;
          case 'edit_grid': // line 634
            console.log(field, 'field***');
            question = new EditGrid({
              label: field['label'],
              resource: field['resource'],
              data: field['data'],
              order: field['order'],
              required: field['required'],
              visible: field['visible'],
              name: field['name'],
              key: field['name'],
              value: field['data'] || [],
              emitDataOnSubmit: field['emitDataOnSubmit'],
            });
            componentFound = true;
            break;
          case 'editgrid': // New editable grid implementation above one will be removed with time
            console.log(field, 'field***');
            question = new EditableGrid({
              label: field['label'],
              resource: field['resource'],
              data: field['data'],
              order: field['order'],
              visible: field['visible'],
              name: field['name'],
              required: field['required'],
              config: {
                items: field['stopInitialization'] != undefined && field['stopInitialization'] ? [] : this.getDataFromResource(field['resource']),
              },
              key: field['name'],
              value: field['data'] != undefined ? field['data'] : []
            });
            if (question.value == undefined || question.value == "") {
              question.value = [];
            }
            componentFound = true;
            // debugger;
            // console.log("this.getDataFromResource(field['resource']) :: ", this.getDataFromResource(field['resource']));
            break;
          case 'rating':
            question = new RatingQuestion({
              key: field['name'],
              label: field['label'],
              order: field['order'],
              required: field['required'],
              disabled: field['disabled'],
              visible: field['visible'],
              value: field['default'] || '',
              req_stars: field['req_stars']
            });
            componentFound = true;
            break;
          case 'score':
            question = new ScoreQuestion({
              key: field['name'],
              label: field['label'],
              order: field['order'],
              required: field['required'],
              disabled: field['disabled'],
              visible: field['visible'],
              scoreType: field['scoreType'] || 'score',
              scoreField: field['scoreField'],
              scoreData: field['scoreData'],
              radio_support: field['radio_support'],
              isScoreData: field['isScoreData'],
              layout_type: field['layout_type'],
              totalScoreDisable: field['totalScoreDisable']
            });
            componentFound = true;
            break;
          case 'tickets':
            question = new TicketsQuestion({
              key: field['name'],
              label: field['label'],
              order: field['order'],
              required: field['required'],
              disabled: field['disabled'],
              visible: field['visible'],
              value: field['default'] || ''
            });
            componentFound = true;
            break;
          case 'hidden':
            question = new HiddenQuestion({
              key: field['name'],
              order: field['order'],
              label: field['label'],
              objectData: field['objectData'],
              dependent: field['dependents'],
              type: field['type'],
              fire_dependent: field['fire_dependent'],
              calculated_field_type: field['calculated_field_type'],
              calculation_formula: field['calculation_formula'],
              select_defination: field['select_defination']
              //required: field['required']
            });
            if ((field['default'] || field['default'] != undefined) || field['default_val']) {
              question.value = this.baseService.buildDyanamicStr(field['default'] || field['default_val'], {});
            }
            else if (field["type"] == 'cardData') {
              console.log("Card Data ", this.cardData);
              var obj = {};
              if (this.cardData != undefined && this.cardData.data != undefined) {
                if (field["keys"]) {
                  for (let i = 0; i < field["keys"].length; i++) {
                    obj[field["keys"][i]] = this.cardData.data[field["keys"][i]];
                  }
                } else {
                  obj = this.cardData.data;
                }
              }
              console.log("Object isresource_directRecieve ", obj);
              if (Object.keys(obj).length) {
                question.value = obj;
              }
            }
            else if (field["name"] == 'facility_id') {
              if (this.appService.getOrganization()) {
                var x = this.appService.getOrganization();
                question.value = x.org_id;
              }
            } else if (field["name"] == 'application_id') {
              if (field["default"] == undefined)
                if (this.appService.getApplication()) {
                  question.value = this.appService.getApplication();;
                }
                else if (field["default"] == false)
                  question.value = undefined;
            }
            else {
              question.value = field['value'];
            }
            componentFound = true;
            break;
          case 'recaptcha':
            question = new CaptchaQuestion({
              key: field['name'],
              objectData: field['objectData'],
              type: field['type'],
              recaptcha: field['recaptcha'],
              //required: field['required']
            });
            componentFound = true;
            break;
          case 'signature':
            question = new SignatureQuestion({
              key: field['name'],
              value: field['value'],
              visible: field['visible'],
              required: field['required'],
              label: field['label'],
              type: field['type'],
              order: field['order']
            });
            componentFound = true;
            break;  
          case 'composite-array':
            question = new CompositeArrayQuestion({
              key: field['name'],
              value: field['value'],
              label: field['label'],
              resource: field['resource'],
              order: field['order'],
              arrayLimit: field['array_limit'],
              visible: field['visible'],
              buttonText: field['buttonText'],
              buttonProps: field['buttonProps'],
              decorator: field['decorator'] || '',
              valid: field['valid'],
              required: (field['required'] != undefined) ? field['required'] : false,
              bannerJson: this.fieldGroup['bannerJson'],
              minWidth: field['min_width'],
              dependentField: field['dependent_field'],
              dependentFieldMap: field['dependent_field_map'],
              populateField: field['populateField'],
              replace_items: field['replace_items'],
              item_key: field['item_key'],
              expression: field['expression'],
              conditions: field['conditions'],
              btnConditions: field['btnConditions'],
              show_label: field['show_label'],
              multiselect:field['multiselect'],
              hideDelete: field['hideDelete'] != undefined ? field['hideDelete'] : false,
              hideEdit: field['hideEdit'] != undefined ? field['hideEdit'] : false,
              hide_edit_conditions: field['hide_edit_conditions'] != undefined ? field['hide_edit_conditions'] : false,
              hide_delete_conditions: field['hide_delete_conditions'] != undefined ? field['hide_delete_conditions'] : false,
              config_add: field['config_add'],
              view_mode: field['view_mode'] != undefined ? field['view_mode'] : false,
              compositePopup: field['compositePopup'] != undefined ? field['compositePopup'] : false,
              hideAdd: field['hideAdd'] != undefined ? field['hideAdd'] : false,
              hideform: field['hideform'] != undefined ? field['hideform'] : false,
              templateInterceptor: field['templateInterceptor'] != undefined ? field['templateInterceptor'] : false,
              button: field['button'],
              filters: field['filters'] != undefined ? field['filters'] : false,
              error_message: field['error_message'] != undefined ? field['error_message'] : '',
              showLastAddedAtTop:field['showLastAddedAtTop'] != undefined ? field['showLastAddedAtTop'] : false,
              persist_position:field['persist_position'] != undefined ? field['persist_position'] : false,
              update_list_outsource: field['update_list_outsource'] != undefined ? field['update_list_outsource'] : false,
              pagination_enabled: field['pagination_enabled'] != undefined ? field['pagination_enabled'] : false,
              complex_search: field['complex_search']
            });
            if (question.value == null)
              question.value = [];
            componentFound = true;
            break;
          case 'custom_form_component':
            question = new CustomFormQuestion({
              key: field['name'],
              value: field['value'],
              selector: field['selector'],
              label: field['label'],
              resource: field['resource'],
              order: field['order'],
              bannerJson: this.fieldGroup['bannerJson'],
              item_key: field['item_key']
            });
            if (question.value == null)
              question.value = [];
            componentFound = true;
            break;
          case 'editable-table':
            question = new EditableTableQuestion({
              key: field['name'],
              value: field['value'],
              resource: field['resource'],
              datasource: field['datasource'],
              fieldDataSource: field['fieldDataSource'],
              order: field['order'],
              minWidth: field['min_width'],
              dependentField: field['dependentField']
            });
            if (question.value == null)
              question.value = [];
            componentFound = true;
            break;
          case 'textbox-button':
            question = new InputButtonQuestion({
              key: field['name'],
              value: field['value'],
              label: field['label'],
              order: field['order'],
              resource: field['resource'],
              enable: field['enable'],
              visible: field['disable'],
              button: field['button'],
              btnText: field['btnText'],
              buttons_config:field['buttons_config'],
              hint:field['hint'],
            });
            componentFound = true;
            break;
          case 'formwithgrid':
            question = new FormWithGrid({
              label: field['label'],
              dataResource: field['datasource'],
              data: field['data'],
              order: field['order'],
              visible: 'true',
              key: field['name'],
              pagination: field['pagination'],
            });
            if (question.value == null) {
              question.value = [];
            }
            componentFound = true;
            break;
          case 'barcode':
            question = new BarcodeQuestion({
              value: field['value'],
              name: field['name'],
              key: field['key'],
              title: field['title'],
              order: field['order']
            });
            componentFound = true;
            break;
          case 'searchselect':
            question = new SearchAndSelect({
              label: field['label'],
              datasource: field['datasource'],
              defaultsetting: field['defaultsetting'],
              order: field['order'],
              popover: field['popover'],
              tooltip: field['tooltip'],
              visible: field['visible'],
              add_fav: field['add_fav'],
              keys_to_remove: field['keys_to_remove'],
              set_template_block: field['set_template_block'],
              key: field['name'],
              disabled: field['disabled'],
              value: field['Value'],
              required: field['required'],
              conditions: field['conditions'],
              id: field['id'],
              getterKey: field['getterKey'],
              getterValue: field['getterValue'] || 'value',
              format: field['format'],
              options: false,
              defaultValue: field['defaultValue'],
              set_object: field['set_object'],
              view_key: field['view_key'],
              placeholder: field['hint'],
              index: field['index'],
              class_conditions: field['class_conditions'],
              flag: field['flag'],
              // getAssignedFacilityList: field['getAssignedFacilityList'] || false,
              req_keys: field['req_keys'],
              stopSorting: field['stopSorting'],
              complexSearchFields: field['complexSearchFields']
            });
            // if (question.default != null) {
            //   question.value = question.default;
            // }
            // if (this.questionsSub[question.key]) {
            //   this.questionsSub[question.key].unsubscribe();
            // }
            // field.datasource.application = field.datasource.application || '';
            // this.setdropdownOptions(field, question, self);
            if (question.value == null || question.value == '') {
              if (question.defaultsetting != undefined && question.defaultsetting.singleSelection != undefined && question.defaultsetting.singleSelection) {
                question.value = "";
              } else {
                question.value = [];
              }
              if(question && question.defaultsetting && question.defaultsetting.singleSelectionValue){
                question.value = "";
              }
            }

            if (this.action == 'VIEW' && (question.view_key == undefined || !question.view_key)) {
              this.setdropdownOptions(field, question, self);
            }
            if (this.action == 'ADD' && question.defaultValue) {
              this.setdropdownOptions(field, question, self);
            }
            // if(question.getAssignedFacilityList){
            //     question.datasource = {possible_value : this.appService.getOrganizationList()}
            // }

            componentFound = true;
            break;
          case 'fileuploader':
            question = new FileUploaderQuestion({
              label: field['label'],
              value: field['value'],
              name: field['name'],
              key: field['name'],
              required: field['required'],
              title: field['title'],
              order: field['order'],
              multiple: field['multiple'],
              conditions: field['conditions'],
              formatsAllowed: field['formatsAllowed'],
              config: {
                hideSelectBtn: field['hideSelectBtn'] != undefined ? field['hideSelectBtn'] : false,
                hideDeleteAPI: field['hideDeleteAPI'] != undefined ? field['hideDeleteAPI'] : false,
                fileuploadertext: field['fileuploadertext'] != undefined ? field['fileuploadertext'] : false,
                isContent: field['isContent'] != undefined ? field['isContent'] : false,
                contentBase64: field['contentBase64'] != undefined ? field['contentBase64'] : false,
              },
              maxSize: field['maxSize'],
              resource: field['resource'],
              formAction: self.action,
              formSubmit: field['formSubmit'],
              s3Document: field['s3Document'],
              crop_image: field['crop_image'] != undefined ? field['crop_image'] : true,
              compress_image: field['compress_image']  != undefined ? field['compress_image'] : true,
              delete_document: field['delete_document'] ? field['delete_document'] : "delete",
              multipleImageUpload: field['multipleImageUpload'] ? field['multipleImageUpload'] : false,
              capture_image: field['capture_image'] ? field['capture_image'] : false,
              icon_with_text: field['icon_with_text'] ? field['icon_with_text'] : false,
              copyURLbtn: field['copyURLbtn'] ? field['copyURLbtn'] : false,
              document_name_field: field['document_name_field']
            });
            componentFound = true;
            break;
          case 'range':
            question = new RangeQuestion({
              key: field['name'],
              label: field['label'],
              type: field['type'],
              required: field['required'],
              order: field['order'],
              resource: field['resource'],
            });
            componentFound = true;
            break;
          case 'inclusion-exclusion':
            question = new InclusionExclusion({
              key: field['name'],
              label: field['label'],
              value: field['value'],
              type: field['type'],
              reload: "",
              required: field['required'],
              order: field['order'],
              resourcelist: field['resourcelist'],
            });
            if (question.value == null)
              question.value = [];
            componentFound = true;
            break;
          case 'monthYearPicker':
            question = new monthYearQuestion({
              key: field['name'],
              label: field['label'],
              value: field['value'],
              type: field['type'],
              visible: field['visible'],
              required: field['required'],
              order: field['order'],
              disabled: field['disabled'],
              placeholder: field['placeholder'],
              format: field['format'],
              disablePreviousYearMonth: field['disablePreviousYearMonth'],
              disableNextYearMonth: field['disableNextYearMonth']
            });
            if (question.value == null)
              question.value = [];
            componentFound = true;
            break;
          case 'range-slider':
            question = new RangeSlider({
              key: field['name'],
              label: field['label'],
              value: field['value'],
              type: field['type'],
              visible: field['visible'],
              required: field['required'],
              order: field['order'],
              min: field['min'] ? field['min'] : 1,
              max: field['max'] ? field['max'] : 10
            });
            componentFound = true;
            break;
            case 'text-entry-question':
              question = new TextEntryQuestion({
                key: field['name'],
                label: field['label'],
                textEntrytype: field['textEntrytype'],
                calculated_field: field['calculated_field'],
                calculation_formula: field['calculation_formula'],
                select_defination: field['select_defination'],
                required: field['required'],
                visible: field['visible'],
                disabled: field['disabled'],
                pattern: field['pattern'],
                maxlength: field['maxlength'],
                minlength: field['minlength'],
                calculated_field_type: field['calculated_field_type']
              });
              if (question.pattern == 'email') {
                question.pattern = '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$'
              }
              else if (question.pattern == 'url') {
                question.pattern = "^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$"
              } else if (question.pattern == 'phone') {
                question.pattern = '[0-9]*'
                question.minlength = 8,
                  question.maxlength = 12
              } else if (question.pattern == 'pincode') {
                question.pattern = '[0-9]*',
                  question.minlength = 6,
                  question.maxlength = 6
              } else if (question.pattern == '#No') {
                question.pattern = '^[0-9+]*$'
              }
              componentFound = true;
              break;
            case 'single-choice-question':
              question = new SingleChoiceQuestion({
                key: field['name'],
                label: field['label'],
                singleChoicetype: field['singleChoicetype'],
                options: field.datasource.possible_value,
                required: field['required'],
                visible: field['visible'],
                disabled: field['disabled'],
                pattern: field['pattern'],
                populate_field: field['populate_field'],
                maxlength: field['maxlength'],
                minlength: field['minlength'],
            });
            if (question.pattern == 'email') {
              question.pattern = '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$'
            }
            else if (question.pattern == 'url') {
              question.pattern = "^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$"
            } else if (question.pattern == 'phone') {
              question.pattern = '[0-9]*'
              question.minlength = 8,
                question.maxlength = 12
            } else if (question.pattern == 'pincode') {
              question.pattern = '[0-9]*',
                question.minlength = 6,
                question.maxlength = 6
            } else if (question.pattern == '#No') {
              question.pattern = '^[0-9+]*$'
            }
            componentFound = true;
            break;
            case 'fingerprint':
              question = new FingerprintQuestion({
                label: field['label'],
                value: field['value'],
                name: field['name'],
                key: field['name'],
                required: field['required'],
                title: field['title'],
                order: field['order'],
                multiple: field['multiple'],
                conditions: field['conditions'],
                formatsAllowed: field['formatsAllowed'],
                maxSize: field['maxSize'],
                formAction: self.action,
                formSubmit: field['formSubmit'],
                crop_image: field['crop_image'] != undefined ? field['crop_image'] : true,
                compress_image: field['compress_image']  != undefined ? field['compress_image'] : true,
                delete_document: field['delete_document'] ? field['delete_document'] : "delete",
                display_image: field['display_image'] ? field['display_image'] : false
              });
              componentFound = true;
              break;
            case 'imageEditor':
              question = new ImageEditorQuestion({
                key: field['name'],
                label: field['label'],
                order: field['order'],
                visible: field['visible'],
                type: field['type'],
                datasource: field['datasource']
              });
              if (question.value == null) question.value = "";
              componentFound = true;
              break;
          default:
            console.error('dhs Form component does not support field type ['
              + field['component'] + ']');
        }

        //added as we need not to set inputs in case of editable grid
        if (!this.editableGrid) {
          if (this.cardData == undefined) {
            this.setInputValue(this.fieldGroup, self.action, field, question, self, this.cardData);
          } else {
            this.setInputValue(this.fieldGroup, self.action, field, question, self, this.cardData.data);
          }
        }
      } else {
        question = this.buildFormGroup(self, field, key);
      }
      question.labelCol = this.labelCol;
      question.className = field['class_name'];

      if (field.dependents != undefined) {
        question.dependents = field.dependents;
      }

      if (field.getterKey != undefined) {
        question.getterKey = field.getterKey;
      }

      if (field.getterValue != undefined) {
        question.getterValue = field.getterValue;
      }

      if (field.dependents != undefined) {
        question.dependents = field.dependents;
      }
      if (field.calculated_field_type != undefined && field.calculated_field_type == "Formula") {
        question.disabled = true;
      }
      //this key will send even invisible keys 
      if (field.sendInvisible != undefined && field.sendInvisible) {
        question.sendInvisible = field.sendInvisible;
        if (this.data?._type != undefined && this.data?._type == 'copy' && !field.visible && this.data[question.key] != undefined && this.data[question.key] != '') {
          question.sendInvisible = false; //178873 if field invisible and sendInvisible is true but user don't want that key in case of copy template 
        }
      }
      //for index in editable grid
      if (field.index != undefined && field.index) {
        question['index'] = field.index;
      }
      //setting block of question
      if (key != undefined && key['block_id'] != undefined && key['block_id']) {
        question['block_id'] = key['block_id'];
      }
      //for proxy
      if (field.proxy_name != undefined && field.proxy_name) {
        question.proxy_name = field.proxy_name;;
      }
      //for visiblity of block
      if (question.key != undefined) {
        if (key != undefined) {
          question['visible'] = question['visible'] == false ? question['visible'] : key.visible;
          question['disabled'] = question['disabled'] == true ? question['disabled'] : key.disabled;
        }
        this.questionMapping[question.key] = question;
      }
      //console.log("Question is ", question);
      //for conditions
      if (question.conditions != undefined && question.conditions.length > 0) {
        // debugger; 
        this.conditionShow(question, self.action);
      }
      return question;
    });
  }
  /**
   * For Dropdown Options
   */

  getDataFromResource(res) {
    this.baseService.getResourceDef(res, (resourceDef) => {
      if (resourceDef) {
        var args = {};

        if (resourceDef.list.hasOwnProperty('APIresource')) {
          if (resourceDef.list.APIresource.datasource.args) {
            args['args'] = resourceDef.list.APIresource.datasource.args
          }
          this.baseService.getData(args, "", resourceDef.list.APIresource.datasource.resource, resourceDef.list.APIresource.datasource.application, resourceDef.list.APIresource.datasource.query_id).subscribe((res) => {
            if (res.errCode === 0 && res.hasOwnProperty("resource")) {
              return res.resource;
            }
          })
        }
        else
          return [];
      }
    })
  }

  getDateRangeFromString(randomSelection,field?){
      var map = {
          "yesterday":{
            "FROM": moment().subtract(1, 'day').startOf('day').valueOf(),
            "TO": moment().subtract(1, 'day').endOf('day').valueOf()
          },
          "this week":{
            "FROM": moment().startOf('week').valueOf(),
            "TO": moment().endOf('week').valueOf()
          },
          "last week":{
            "FROM": moment().subtract(1, 'week').startOf('week').valueOf(),
            "TO": moment().subtract(1, 'week').endOf('week').valueOf()
          },
          "this month":{
            "FROM": moment().startOf('month').valueOf(),
            "TO": moment().endOf('month').valueOf()
          },
          "last month":{
            "FROM": moment().startOf('month').subtract(1, 'month').startOf('month').valueOf(),
            "TO": moment().startOf('month').subtract(1, 'month').endOf('month').valueOf()
          },
      }
      var endOfDay = (field && field['endOfDay'])?field['endOfDay']:false;

      if(randomSelection && randomSelection.toLowerCase != undefined && map[randomSelection.toLowerCase()] != undefined){
        return map[randomSelection];
      }else{
        var obj = {
          "FROM": moment().subtract(randomSelection, 'days').startOf('day').valueOf(),
          "TO": endOfDay ? this.baseService.getTodayEndMillis() : this.baseService.getCurrentDate(),
        }
  
        return obj
      }
     
  }

  getAfterRangeFromString(defaultDaysAfter){
      var obj = {
        "FROM": this.baseService.getTodayMillis(),
        "TO": moment().add(defaultDaysAfter, 'days').endOf('day').valueOf(),
      }
      return obj
}

  mapDictToArray(dto: any, field: any) {
    let result;
    if (Array.isArray(dto)) {
      if (field.datasource != undefined && field.datasource.composite != undefined) {
        if (dto[0] != undefined && dto[0][field.datasource.composite] != undefined) {
          if (Array.isArray(dto[0][field.datasource.composite])) {
            dto = dto[0][field.datasource.composite];
          } else {
            dto = [];
          }
        } else {
          dto = [];
        }
      }
      result = [];
      console.log("Object dto", dto);
      for (let obj of dto) {
        if (obj && obj.hasOwnProperty(field['getterKey']) && (field.req_keys == undefined || field.req_keys == false)) {
          result.push({
            [field['getterKey']]: obj[field['getterKey']],
            [field['getterValue']]: obj[field['getterValue']]
          });
        }
        else {
          if (field.req_keys != undefined) {
            if (field.req_keys == 'all') {
              result.push(obj);
            } else {
              let firstObj = {};
              let secondObj = {};
              field.req_keys.forEach(element => {
                secondObj = Object.assign(firstObj, { [element]: obj[element] })
              });
              result.push(secondObj);
            }

          }
        }
      }
    }
    else {
      result = dto;
    }
    return result;
  }
  setdropdownOptions(field, question, self) {
    var dataSourceFound: any = false;
    if (field.conditions != undefined && field.conditions.length) {
      var currentUserType = this.authenticationService.getUserType();
      var currentApplication = this.appService.getApplication();
      for (let index = 0; index < field.conditions.length; index++) {
        var singleCondition = field.conditions[index];
        switch (singleCondition.action) {
          case 'change_value':
            dataSourceFound = this.getDataSourceForApplication(singleCondition, currentApplication);
            if (dataSourceFound) {
              dataSourceFound = this.getDataSourceForUser(dataSourceFound, currentUserType);
              if (dataSourceFound) {
                dataSourceFound.application = dataSourceFound.resource_application;
                break;
              }
            }
            break;
          //to be handled for dropdown conditions
          // case 'visible':
          //   this.setFieldVisibiltiy(question, true);
          //   break;
          // case 'invisible':
          //   this.setFieldVisibiltiy(question, false);
          //   break;
          // case 'enable':
          //   this.setFieldEnabled(question, false);
          //   break;
          // case 'disable':
          //   this.setFieldEnabled(question, true);
          //   break;
          default:
            //do nothing
            break;

        }
      }
    }
    if (!dataSourceFound) {
      dataSourceFound = field.datasource;
    }

    // if (!(question.controlType == "pullable")) {
    if (dataSourceFound && !dataSourceFound.possible_value && (Object.keys(dataSourceFound).length > 0 && dataSourceFound.application != undefined && dataSourceFound.application)) {
      dataSourceFound = JSON.parse(JSON.stringify(dataSourceFound));
      if (self && self.popupForm != undefined && this.popupForm != undefined && this.popupForm["parentForm"] != undefined) {
        var obj = JSON.parse(JSON.stringify(this.popupForm["parentForm"].value));
        for (let key in obj) {
          obj["parent__" + key] = obj[key];
          delete obj[key];
        }
        var formData = { ...obj, ...self.popupForm.getRawValue() };
        if (this.route.snapshot.params.foreign_id != undefined) {
          formData.foreign_id = this.route.snapshot.params.foreign_id;
        }
        if (dataSourceFound.args != undefined && dataSourceFound.args) {
          dataSourceFound.args = this.baseService.buildDyanamicStr(dataSourceFound.args, { data: formData });
        }
        if (dataSourceFound.filter != undefined && dataSourceFound.filter) {
          dataSourceFound.filter = this.baseService.buildDyanamicStr(dataSourceFound.filter, { data: formData });
        }
      } else {
        var data = {};
        if (this.route.snapshot.queryParams["filterData"] != undefined && this.route.snapshot.queryParams["filterData"] != "") {
          try {
            data = JSON.parse(this.route.snapshot.queryParams["filterData"]);

          } catch (e) {

          }
        }
        if (self)
          self.data = (self.data != undefined) ? { ...self.data, ...data } : data;
        if (this.route.snapshot.params.foreign_id != undefined) {
          self.data.foreign_id = this.route.snapshot.params.foreign_id;
        }
        if (dataSourceFound.args != undefined && dataSourceFound.args) {
          if (self == undefined && this.cardData && this.cardData.data)
            dataSourceFound.args = this.baseService.buildDyanamicStr(dataSourceFound.args, this.cardData);
          else
            dataSourceFound.args = this.baseService.buildDyanamicStr(dataSourceFound.args, self);
        }
        if (dataSourceFound.filter != undefined && dataSourceFound.filter) {
          dataSourceFound.filter = this.baseService.buildDyanamicStr(dataSourceFound.filter, self != undefined ? self : {});
        }
      }
      // if (dataSourceFound && dataSourceFound.query_id != undefined && dataSourceFound.query_id === "GET_ALL") {
      //   dataSourceFound.query_id = "GET_PAGE";
      //   dataSourceFound['page_no'] = 0;
      //   dataSourceFound['page_size'] = 20;
      // }

      if (question.controlType == 'searchselect') {
        //if its search select we just need to replace datasource, it will itself fire the api and bind the options
        question.datasource = dataSourceFound;
        if ((this.action == 'VIEW' && (question.view_key == undefined || !question.view_key)) || (this.action == 'ADD' && question.defaultValue)) {
          this.getDictionary(dataSourceFound.resource, dataSourceFound.query_id, dataSourceFound.application, dataSourceFound.args ? dataSourceFound.args : null, dataSourceFound.filter ? dataSourceFound.filter : null, question)
            .subscribe((data) => {
              question.options = this.mapDictToArray(data, field);
              if (question.defaultValue && question.defaultValue != undefined && (this.action == 'ADD' || this.action == 'SEARCH')) {
                this.setDefaultVal(question);
              }
            })
        }
      } else {
        var getDropdownData = this.getDictionary(dataSourceFound.resource, dataSourceFound.query_id, dataSourceFound.application, dataSourceFound.args ? dataSourceFound.args : null, dataSourceFound.filter ? dataSourceFound.filter : null, question, dataSourceFound.read_scope_level ? dataSourceFound.read_scope_level : undefined)
          .subscribe(
            (data) => {
              var value: any;
              question.options = this.mapDictToArray(data, field);

              if (question.defaultValue && question.defaultValue != undefined && (this.action == 'ADD' || this.action == 'SEARCH')) {
                this.setDefaultVal(question);
              }
              if (question.default != null && this.action == 'ADD' && !question.value) {
                question.value = question.default.trim();
              }
              if ((question.controlType == "textbox" || question.controlType == "daterangepicker" || question.controlType == "numberbox") && field.datasource != undefined && field.datasource.setValue != undefined && field.datasource.setValue) {
                if (this.form != undefined && data != undefined && data != null && data.length > 0) {
                  this.form.controls[question.key].setValue(data[0][field.datasource.setValue]);
                  this.form.controls[question.key]["question_component"].updateDependentValue(data[0][field.datasource.setValue]);
                } else if (question.controlType == "edit_grid") {
                  this.form.controls[question.key].setValue(data[0]);
                } else if (this.popupForm != undefined && data != undefined && data != null && data.length > 0) {
                  this.popupForm.controls[question.key].setValue(data[0][field.datasource.setValue]);
                  this.popupForm.controls[question.key]["question_component"].updateDependentValue(data[0][field.datasource.setValue]);
                }
              }

              this.setOpionChanged(question);//emitting that options are set
            }
          );
      }
    }
    // }
    else if (dataSourceFound && dataSourceFound.possible_value != undefined && dataSourceFound.possible_value.length > 0) {
      new Promise((resolve, reject) => {
        resolve(dataSourceFound.possible_value);
      }).then((options) => {
        question.options = options;
        this.setOpionChanged(question);//emitting that options are set
        if (question.defaultValue && question.defaultValue != undefined) {
          this.setDefaultVal(question);
        }
      });
    } else {
      new Promise((resolve, reject) => {
        question.options = [];
        resolve(question.options);
      }).then((options) => {
        this.setOpionChanged(question);//emitting that options are set 
      });
    }

    //console.log(question);
  }

  setPullableOptions(field, question, self) {
    var dataSourceFound: any = false;
    if (field.conditions != undefined && field.conditions.length) {
      var currentUserType = this.authenticationService.getUserType();
      var currentApplication = this.appService.getApplication();
      for (let index = 0; index < field.conditions.length; index++) {
        var singleCondition = field.conditions[index];
        switch (singleCondition.action) {
          case 'change_value':
            dataSourceFound = this.getDataSourceForApplication(singleCondition, currentApplication);
            if (dataSourceFound) {
              dataSourceFound = this.getDataSourceForUser(dataSourceFound, currentUserType);
              if (dataSourceFound) {
                dataSourceFound.application = dataSourceFound.resource_application;
                break;
              }
            }
            break;
          //to be handled for dropdown conditions
          // case 'visible':
          //   this.setFieldVisibiltiy(question, true);
          //   break;
          // case 'invisible':
          //   this.setFieldVisibiltiy(question, false);
          //   break;
          // case 'enable':
          //   this.setFieldEnabled(question, false);
          //   break;
          // case 'disable':
          //   this.setFieldEnabled(question, true);
          //   break;
          default:
            //do nothing
            break;

        }
      }
    }
    if (!dataSourceFound) {
      dataSourceFound = field.pullableData;
    }

    if ((Object.keys(dataSourceFound).length > 0 && dataSourceFound.application != undefined && dataSourceFound.application)) {
      if (dataSourceFound.args != undefined && dataSourceFound.args) {
        dataSourceFound.args = this.baseService.buildDyanamicStr(dataSourceFound.args, self);
      }

      if (question.controlType == 'searchselect') {
        //if its search select we just need to replace datasource, it will itself fire the api and bind the options
        question.datasource = dataSourceFound;
      } else {
        var getDropdownData = this.getDictionary(dataSourceFound.resource, dataSourceFound.query_id, dataSourceFound.application, dataSourceFound.args ? dataSourceFound.args : null, dataSourceFound.filter ? dataSourceFound.filter : null, question)
          .subscribe(
            (data) => {
              this.dropdownoptionAdapter(question,data,field);
            }
          );
      }
    }
    // else if (dataSourceFound.possible_value != undefined && dataSourceFound.possible_value.length > 0) {
    //   new Promise((resolve, reject) => {
    //     resolve(dataSourceFound.possible_value);
    //   }).then((options) => {
    //     question.options = options;
    //     this.setOpionChanged(question);//emitting that options are set
    //     if (question.defaultValue && question.defaultValue != undefined) {
    //       this.setDefaultVal(question);
    //     }
    //   });
    // } 
    else {
      question.options = [];
      this.setOpionChanged(question);//emitting that options are set
    }

    //console.log(question);
  }


  dropdownoptionAdapter(question,data,field){
    var value: any;
    question.options = this.mapDictToArrayPullable(data, field);

    if (question.defaultValue && question.defaultValue != undefined) {
      this.setDefaultVal(question);
    }
    if (question.default != null && this.action == 'ADD') {
      question.value = question.default.trim();
    }
    if ((question.controlType == "pullable") && field.pullableData != undefined) {
      if (this.form != undefined && data != undefined && data != null && data.length > 0) {
        this.form.controls[question.key].setValue(data[0][field.pullableData]);
      } else if (question.controlType == "edit_grid") {
        this.form.controls[question.key].setValue(data[0]);
      } else if (this.popupForm != undefined && data != undefined && data != null && data.length > 0) {
        this.popupForm.controls[question.key].setValue(data[0][field.pullableData.setValue]);
      }
    }

    this.setOpionChanged(question);//emitting that options are set
  }

  mapDictToArrayPullable(dto: any, field: any) {
    let result;
    if (Array.isArray(dto)) {
      if (field.pullableData != undefined && field.pullableData.composite != undefined) {
        if (dto[0] != undefined && dto[0][field.pullableData.composite] != undefined) {
          if (Array.isArray(dto[0])) {
            dto = dto[0][field.pullableData.composite];
          } else {
            dto = [];
          }
        } else {
          dto = [];
        }
      }
      result = [];
      console.log("Object dto", dto);
      for (let obj of dto) {
        if (obj && obj.hasOwnProperty(field['getterKey']) && (field.req_keys == undefined || field.req_keys == false)) {
          result.push({
            [field['getterKey']]: obj[field['getterKey']],
            [field['getterValue']]: obj[field['getterValue']]
          });
        }
        else {
          if (field.req_keys != undefined) {
            if (field.req_keys == 'all') {
              result.push(obj);
            } else {
              let firstObj = {};
              let secondObj = {};
              field.req_keys.forEach(element => {
                secondObj = Object.assign(firstObj, { [element]: obj[element] })
              });
              result.push(secondObj);
            }

          }
        }
      }
    }
    else {
      result = dto;
    }
    return result;
  }

  setOpionChanged(question) {
    this.optionChanged.next({ question: question });

  }

  getOpionChanged(): Observable<any> {
    return this.optionChanged.asObservable();
  }
  conditionShow(question, current_action?) {
    if (question.conditions != undefined && question.conditions.length > 0) {
      var currentUserType = this.authenticationService.getUserType();
      var currentApplication = this.appService.getApplication();
      var disableDone = false;
      var invisibleDone = false;
      for (let i = 0; i < question.conditions.length; i++) {
        let currentConditions = question.conditions[i];
        /**** FOR APPLICATION ****/
        if (currentConditions.application != undefined) {
          if (currentConditions.application.indexOf(currentApplication) > -1) {
            if (currentConditions.action == 'disable') {
              question.disabled = true;
              disableDone = true;
            }

            if (currentConditions.action == 'invisible') {
              question.visible = false;
              invisibleDone = true;
            }
          }
        }

        /**** FOR USER TYPE ****/
        if (currentConditions.user_type != undefined) {
          if (currentConditions.user_type.indexOf(currentUserType) > -1) {
            if (!disableDone) {
              if (currentConditions.action == 'disable') {
                question.disabled = true;
                disableDone = true;
              }
            }

            if (!invisibleDone) {
              if (currentConditions.action == 'invisible') {
                question.visible = false;
                invisibleDone = true;
              }
            }
          }
        }
        /**** FOR USER TYPE ****/

        /**** FOR ACTIONS ****/
        if (currentConditions.resource_action != undefined) {
          if (currentConditions.resource_action.indexOf(current_action) > -1) {
            if (!disableDone) {
              if (currentConditions.action == 'disable') {
                //added question.visible as in case of disable field should be visible
                question.visible = true;
                question.disabled = true;
                disableDone = true;
              }
            }

            if (!invisibleDone) {
              if (currentConditions.action == 'invisible') {
                question.visible = false;
                invisibleDone = true;
              }
            }
          }
        }
        /**** FOR USER TYPE ****/
        if (currentConditions.config_type_condition != undefined && currentConditions.config_type_condition) {
          // if (currentConditions.config_type.indexOf(current_action) > -1) {
          if (!this.appService.getUniversalConfig(currentConditions.config)) {
            if (!invisibleDone) {
              if (currentConditions.action == 'invisible') {
                question.visible = false;
                question.populate_field = false;
                invisibleDone = true;
              }
            }
          }
          // }
        }
      }
    }
  }
  setDefaultVal(question) {
    let e = "";
    if (typeof (question.defaultValue) == 'object') { // setting default value on basis of other key
      e = question.options.find(x => x[question.defaultValue.key] == question.defaultValue.value);
    } else {
      e = question.options.find(x => x[question.getterValue].toLowerCase() == question.defaultValue.toLowerCase());
    }
    if (e) {
      question.value = e[question.getterKey];
      if (this.form != undefined && this.form.controls != undefined && this.form.controls[question.key] != undefined) {
        this.form.controls[question.key].setValue(question.value);
      }
      //for dependent fields 
      if (this.form != undefined && this.form.controls != undefined && this.form.controls[question.key] != undefined && this.form.controls[question.key]["question_component"] != undefined) {
        this.form.controls[question.key]["question_component"].updateDependentValue(question.value);
      }
    }
  }
  getDataSourceForApplication(singleCondition, currentApplication) {
    if (singleCondition.application != undefined && singleCondition.application.length) {
      if (singleCondition.application.indexOf(currentApplication) > -1) {
        return singleCondition;
      } else {
        return false;
      }
    }
    return singleCondition;
  }
  getDataSourceForUser(singleCondition, currentUserType) {
    if (singleCondition.user_type != undefined && singleCondition.user_type.length) {
      if (singleCondition.user_type.indexOf(currentUserType) > -1) {
        return singleCondition;
      } else {
        return false;
      }
    }
    return singleCondition;
  }
  //For Field Visibility

  private extractData(res, cacheObj?) {
    let data = (res != undefined) ? res.data || res : [];
    if (cacheObj) {
      let key = CryptoJS.MD5(cacheObj.toString()).toString();
      this.baseService.setCachedData(key, data);
    }
    return data;
  }
  loopBlocks(blocks, allBlocksAr, index, callback) {
    if (this.form == undefined && this.popupForm == undefined) {
      callback(false);
      return;
    }
    if (blocks.length) {
      var singleBlocks = blocks.shift();
      if (singleBlocks.questions != undefined && singleBlocks.questions.length) {
        //if block is invisible or disabled , we don't need to check field for validity it should be valid anyway
        if (!singleBlocks.visible || singleBlocks.disable) {
          allBlocksAr[index].valid = true;
          index++;
          this.loopBlocks(blocks, allBlocksAr, index, callback);
        } else {
          this.loopFields(JSON.parse(JSON.stringify(allBlocksAr[index].questions)), allBlocksAr[index].questions, 0, (questions, valid) => {
            allBlocksAr[index].questions = questions;
            allBlocksAr[index].valid = valid;
            index++;
            this.loopBlocks(blocks, allBlocksAr, index, callback);
          });
        }

      } else {
        index++;
        this.loopBlocks(blocks, allBlocksAr, index, callback);
      }
    } else {
      //checking if all blocks are valid
      if (allBlocksAr.length) {
        var valid = true;
        for (let index1 = 0; index1 < allBlocksAr.length; index1++) {
          var block = allBlocksAr[index1];
          if (!block.valid) {
            valid = block.valid;
            break;
          }
        }
        callback(allBlocksAr, valid);
      } else {
        callback(allBlocksAr, true);
      }
    }
  }

  loopFields(fields, allFields, index, callback) {
    var form: any;
    if (this.form != undefined) {
      form = this.form;
    } else if (this.popupForm != undefined) {
      form = this.popupForm;
    }
    if (fields.length) {
      var singleFields = fields.shift();

      if (Array.isArray(singleFields)) {
        this.loopBlocks(JSON.parse(JSON.stringify(allFields[index])), allFields[index], 0, (compRes, valid) => {
          allFields[index] = compRes;
          allFields[index].valid = valid;
          index++;
          this.loopFields(fields, allFields, index, callback);
        });
      } else {

        if (form.controls[singleFields.key] != undefined && (!form.controls[singleFields.key].disabled) && (!form.controls[singleFields.key].valid)) {
          console.log('field invalid', singleFields.key);
          // field is invalid, i.e entire form block is invalid
          callback(allFields, false);
        } else {
          if (singleFields.controlType == "composite-array") {
            if (singleFields.required) {
              if (form.controls[singleFields.key] != undefined && form.controls[singleFields.key].value != undefined && form.controls[singleFields.key].value.length > 0) {
                index++;
                this.loopFields(fields, allFields, index, callback);
              } else {
                callback(allFields, false);
              }
            } else {
              index++;
              this.loopFields(fields, allFields, index, callback);
            }


          } else if (form.controls[singleFields.key] != undefined && (!form.controls[singleFields.key].disabled) && (!form.controls[singleFields.key].valid)) {
            console.log('field invalid', singleFields.key);
            // field is invalid, i.e entire form block is invalid
            callback(allFields, false);
          } else {
            index++;
            this.loopFields(fields, allFields, index, callback);
          }

        }

      }
    } else {
      //checking if all fields (actully blocks) are valid
      if (allFields.length) {
        var valid = true;
        for (let index1 = 0; index1 < allFields.length; index1++) {
          var block = allFields[index1];
          if (block.valid != undefined && !block.valid) {
            valid = block.valid;
            break;
          } else if (block.key != undefined && form.controls[block.key] != undefined && (!form.controls[block.key].disabled) && (!form.controls[block.key].valid)) {
            // field is invalid, i.e entire form block is invalid
            valid = false;
            break;
          }
        }
        callback(allFields, valid);
      } else {
        callback(allFields, true);
      }

    }
  }


  findBlock(nameToFind, blocksAr, allBlocksAr, index) {
    if (allBlocksAr.length) {
      var singleBlocks = allBlocksAr.shift();
      var singleBlocksOrig = blocksAr[index];
      index++;
      if (singleBlocks.block_id != undefined && singleBlocks.block_id == nameToFind) {
        return singleBlocksOrig;
      } else {
        if (singleBlocks.questions != undefined && singleBlocks.questions.length) {
          var response = this.findBlockInQuestions(nameToFind, singleBlocksOrig.questions, singleBlocks.questions, 0);
          if (response) {
            return response;
          } else {
            return this.findBlock(nameToFind, blocksAr, allBlocksAr, index);
          }
        } else {
          return this.findBlock(nameToFind, blocksAr, allBlocksAr, index);
        }
      }

    } else {
      return false;
    }
  }

  findBlockInQuestions(nameToFind, fields, allFields, index) {
    if (allFields.length) {
      var singleFields: any;
      singleFields = allFields.shift();
      var singleFieldOrig = fields[index];
      index++;
      if (Array.isArray(singleFields)) {
        var response = this.findBlock(nameToFind, singleFieldOrig, singleFields, 0);
        if (response) {
          return response;
        } else {
          return this.findBlockInQuestions(nameToFind, fields, allFields, index);
        }
      } else {
        //Its a field
        return this.findBlockInQuestions(nameToFind, fields, allFields, index);
      }
    } else {
      return false;
    }
  }
  setBlocksChange(blocksChange) {
    this.blocksChange = blocksChange;
  }
  sendSelectedObject(result, key, prefix) {
    if (!this.blocksChange.includes(prefix)) {
      delete result[key];
    }
  }

  /*
* 
//it will remove the field whose status is not visible
* this function can further be enhanced to remove unnecessary formvalues
*/
  filterValuesBasedOnFieldStatus(result, prefix: any = false) {
    for (let key in result) {
      let newPrefix = (prefix) ? prefix + "." + key : key;
      if (result[key] != undefined) {
        if (this.action == 'MODIFY' && this.config != undefined && this.config.delta_update) {
          if (typeof result[key] == 'object' && !Array.isArray(result[key])) {
            this.sendSelectedObject(result, key, newPrefix);
          } else if (Array.isArray(result[key])) {
          } else {
            if (this.questionMapping[newPrefix] != undefined && !this.questionMapping[newPrefix]['_manualChange']) {
              this.removeKey(newPrefix, result, key);
            }
          }
        } else {
          if (typeof result[key] == 'object' && !Array.isArray(result[key])) {
            this.filterValuesBasedOnFieldStatus(result[key], newPrefix);
          } else {
            if (this.questionMapping[newPrefix] != undefined && this.questionMapping[newPrefix].visible != undefined) {
              this.removeKey(newPrefix, result, key);
            }
          }
        }
      }
    }
    return result;
  }

  //remove unwanted keys
  removeKey(newPrefix, result, key) {
    if ((!this.questionMapping[newPrefix].visible && !this.questionMapping[newPrefix].sendInvisible) || (!this.questionMapping[newPrefix]['_manualChange'] && this.action == 'MODIFY' && this.config != undefined && this.config.delta_update)) {
      console.log("key Removed from the form object==>>", newPrefix);
      delete result[key];
    }
    else {
      //handling proxy
      if (this.questionMapping[newPrefix].proxy_name != undefined) {
        var newKey: any = this.questionMapping[newPrefix].proxy_name.split(".");
        newKey = newKey[newKey.length - 1];
        if (typeof result[key] == "object") {
          result[newKey] = JSON.parse(JSON.stringify(result[key]));
        } else {
          result[newKey] = result[key];
        }
        delete result[key];
      }
      //handling proxy
    }
  }
  // Template Score Calculation
  calculatefieldAll(form) {
    if (form != undefined) {
      this.form = form;
    }
    if (this.form && this.form.controls) {
      Object.keys(this.form.controls).forEach(key => {
        if (this.form.controls && this.form.controls[key] && this.form.controls[key]['question_component'] && this.form.controls[key]['question_component'].question && this.form.controls[key]['question_component'].question.calculated_field_type && (this.form.controls[key]['question_component'].question.calculated_field_type == "Formula" || this.form.controls[key]['question_component'].question.calculated_field_type == "formula_enable")) {
          this.keyValue = this.form.controls[key]['question_component'].question.key;
          this.formatValue = this.form.controls[key]['question_component'].question.calculation_formula;
          console.log("Formula 2::::: " + this.formatValue);
          if (this.formatValue) {
            this.setFormula(this.keyValue);
          }
        }
      });
    }
  }
  calculatefield(e:any) { 
    if (this.form && this.form.controls) {
      Object.keys(this.form.controls).forEach(key => {
        if (this.form.controls && this.form.controls[key] && this.form.controls[key]['question_component'] && this.form.controls[key]['question_component'].question && this.form.controls[key]['question_component'].question.calculated_field_type && (this.form.controls[key]['question_component'].question.calculated_field_type == "Formula" || this.form.controls[key]['question_component'].question.calculated_field_type == "formula_enable")) {
          this.keyValue = this.form.controls[key]['question_component'].question.key;
          this.formatValue = this.form.controls[key]['question_component'].question.calculation_formula;
          if (e.question.key != null ){
            // console.log("Question Key is::::: " + e.question.key);
              if(this.formatValue && this.formatValue.includes(e.question.key)) {
              console.log("Inside Calcuate Formula::::: " + e.question.key +"--,--"+ this.formatValue +"--,--"+  key);
              // console.log(`The key '${key}' exists in the formula.`);
              this.setFormula(this.keyValue);
              this.calculatefield(this.form.controls[key]['question_component']);
            }
          }
          else{
            console.log("Formula is::::: " + this.formatValue);
            this.setFormula(this.keyValue);
          }
        }
      });
    }
  }
  setFormula(keyValue:any) {
    let result;
    Object.keys(this.form.controls).forEach(key1 => {
      var removeStr = `\\b${key1}\\b`;
      const regex = new RegExp(removeStr, 'g'); // correct way
      let value;
      if ((this.formatValue.includes(key1)) && this.form.controls[key1] && (this.form.controls[key1].value == "" || this.form.controls[key1].value == null)) {
        value = 0;
      }
      else {
        value = this.form.controls[key1].value;
      }
      this.formatValue = this.formatValue.replace(regex, value);
    });
    try {
      console.log("Format Value::::!!!", this.formatValue);
      result = eval(this.formatValue);
      console.log("Key Found::::!!!", keyValue + " , Final Result is::::!!!", result);
      if (result != undefined){
        this.form.controls[keyValue].setValue(result);
        if (this.form.controls[keyValue]['question_component'] && this.form.controls[keyValue]['question_component'].question.dependents && this.form.controls[keyValue]['question_component'].question.dependents.length > 0){
          this.form.controls[keyValue]['question_component'].updateDependentValue(this.form.controls[keyValue].value); 
        }
      }
    } catch (error) {
      console.log("Wrong Input!!!", keyValue);
    }
  }

  checkAutosaveForTemp(field) {
    //this case is
    if (!this.fromRuntime && this.config != undefined && this.config.autoSave != undefined && this.config.autoSave && field != undefined && field.name != undefined && (field.name == 'templateName' || field.name == 'templateType' || field.name == 'title' || field.name == 'confidential')) {
      return false;
    }
    else {
      return true;
    }
  }

  fetchCheckboxKey() {
    try {
      const location_id = this.appService.getCurrentLocation()?.location_id || '';
      const checkboxStates: { [key: string]: any } = {};
      if (this.config["resource_config"]?.editGridCheckboxState?.length > 0) {
        for (const gridConfig of this.config["resource_config"].editGridCheckboxState) {
          const formControlName = gridConfig.form_control;
          const resourceName = gridConfig.resource;
          if (this.form.value[formControlName]) {
            const key = `${resourceName}_${location_id}_checkbox_state`;
            const savedState = sessionStorage.getItem(key);
            if (savedState) {
              try {
                checkboxStates[formControlName] = {
                  key: key,
                  resource: resourceName,
                  data: JSON.parse(savedState)
                };
              } catch (parseError) {
                console.error(`Error parsing checkbox state for ${formControlName}:`, parseError);
              }
            }
          }
        }
      }
      return checkboxStates;
    } catch (error) {
      console.error('Error fetching checkbox keys:', error);  
      return {};
    }
  }

  attachSelectedItemsToResult(result: any): any {
    try {
      if (this.config["resource_config"]?.editGridCheckboxState?.length > 0) {
        for (const gridConfig of this.config["resource_config"].editGridCheckboxState) {
          const formControlName = gridConfig.form_control;
          const selectedItems = this.getSelectedItemsForGrid(formControlName);
          if (selectedItems.length > 0) {
            result[`${formControlName}`] = selectedItems;
          }
        }
      }
      return result;
    } catch (error) {
      console.error('Error attaching selected items:', error);
      return result;
    }
  }

  getSelectedItemsForGrid(formControlName: string): any[] {
    try {
      const checkboxStates = this.fetchCheckboxKey();
      if (checkboxStates[formControlName]?.data) {
        return checkboxStates[formControlName].data.map(item => item.CompleteItem || item);
      }
      return [];
    } catch (error) {
      console.error(`Error getting selected items for ${formControlName}:`, error);
      return [];
    }
  }

}

